import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g clipPath="url(#clip0_5868_38564)">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C6.27673 0 2.91242 4.26647 2.45398 8.58625C1.02762 9.06489 0 10.4124 0 12V14.4C0 16.3882 1.61178 18 3.6 18C5.58823 18 7.2 16.3882 7.2 14.4V12C7.2 10.5808 6.37878 9.35341 5.18561 8.7671C5.50256 5.66899 7.59769 2.4 12 2.4C16.4023 2.4 18.4974 5.66899 18.8144 8.7671C17.6212 9.35341 16.8 10.5808 16.8 12V14.4C16.8 15.4662 17.2635 16.4241 18 17.0833V18.7444C18 20.3215 16.7215 21.6 15.1444 21.6H14.4C13.7373 21.6 13.2 22.1373 13.2 22.8C13.2 23.4627 13.7373 24 14.4 24H15.1444C18.047 24 20.4 21.647 20.4 18.7444V18C22.3882 18 24 16.3882 24 14.4V12C24 10.4124 22.9724 9.06489 21.546 8.58626C21.0876 4.26647 17.7233 0 12 0ZM4.8 12C4.8 11.3373 4.26274 10.8 3.6 10.8C2.93726 10.8 2.4 11.3373 2.4 12V14.4C2.4 15.0627 2.93726 15.6 3.6 15.6C4.26274 15.6 4.8 15.0627 4.8 14.4V12ZM20.4 10.8C21.0627 10.8 21.6 11.3373 21.6 12V14.4C21.6 15.0627 21.0627 15.6 20.4 15.6C19.7373 15.6 19.2 15.0627 19.2 14.4V12C19.2 11.3373 19.7373 10.8 20.4 10.8Z"
      fill={fill}
    />
  </g>
);

export default Icon;
